<li>
   <div
      [ngClass]="{ 'opacity-50 cursor-not-allowed': node.disabled }"
      class="node-row flex align-items-center gap-2"
      (click)="onNodeRowClick($event)"
   >
      <span *ngIf="node.children?.length" class="toggle flex align-items-center">
         <i
            [ngClass]="node.expanded ? 'pi pi-angle-down' : 'pi pi-angle-right'"
            class="text-600"
            style="font-size: 1.24rem"
         ></i>
      </span>
      <input
         *ngIf="node.leaf"
         [type]="selectionMode === 'single' ? 'radio' : 'checkbox'"
         [checked]="isSelected()"
         [disabled]="node.disabled"
         class="list-none pl-3"
         (click)="$event.stopPropagation(); selectLeaf()"
         name="tree-select"
      />
      <span class="label flex align-items-center gap-2">
         <i *ngIf="node.icon" [ngClass]="node.icon"></i>
         {{ node.label }}
      </span>
   </div>

   <ul *ngIf="node.expanded && node.children?.length" style="display: grid" class="gap-3 px-2 pt-2 pl-3 list-none">
      <app-tree-select-node
         *ngFor="let child of node.children"
         [node]="child"
         [selectionMode]="selectionMode"
         [selectedNodes]="selectedNodes"
         (leafSelected)="leafSelected.emit($event)"
      ></app-tree-select-node>
   </ul>
</li>
